import AxiosInstance, { ApiResponse } from 'api';
import { getItemFromLocalStorage, storeInLocalStorage } from 'helpers/cache';
import { useState } from 'react';

export const useFetchContentAndCache = <T>(
  url: string,
  resourceKey: string,
  expiryInHours?: number
): T | null => {
  const [cachedContent, setCachedContent] = useState<T | null>(() =>
    getItemFromLocalStorage(resourceKey)
  );

  if (!cachedContent) {
    try {
      AxiosInstance.request<ApiResponse<T>>({ url: url }).then((response) => {
        if (response.data.status === '1') {
          storeInLocalStorage(
            response.data.details,
            resourceKey,
            expiryInHours
          );
          setCachedContent(response.data.details);
        } else {
          throw new Error();
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  return cachedContent;
};
